import type { CommunicationBlockIdValue } from './communicationBlocks';
import type { CommunicationEmailAudienceValue } from '@/pages/CycleEvaluation/Communications/communicationEmailAudience';
import type { LocalizedText } from '@/utils/localization';
import type { Descendant } from 'slate';

import { CommunicationEmailAudience } from '@/pages/CycleEvaluation/Communications/communicationEmailAudience';
import { getEmptyEmailMessage } from '@/utils/schedule';

export interface CommunicationCardState {
    enabled: boolean;
    language: string;
    titleByLanguage: LocalizedText;
    messageByLanguage: Record<string, Descendant[]>;
    customizedLanguages: Set<string>;
    testEmailAddress: string;
}

export type CommunicationCardKey =
    `${CommunicationBlockIdValue}:${CommunicationEmailAudienceValue}`;

export const cardKey = (
    blockId: CommunicationBlockIdValue,
    audience: CommunicationEmailAudienceValue,
): CommunicationCardKey => `${blockId}:${audience}`;

export const isEmployeeCard = (key: CommunicationCardKey): boolean =>
    key.endsWith(`:${CommunicationEmailAudience.EMPLOYEE}`);

export const cardCurrentTitle = (card: CommunicationCardState | undefined): string =>
    card ? (card.titleByLanguage[card.language] ?? '') : '';

export const cardCurrentMessage = (card: CommunicationCardState | undefined): Descendant[] =>
    card
        ? (card.messageByLanguage[card.language] ?? getEmptyEmailMessage())
        : getEmptyEmailMessage();
